.adminMark {
  color: #2a8fe6;
  font-size: 0.8rem;
}

.accountMenuWrap {
  position: relative;
}

.avatarButton {
  cursor: pointer;
  position: relative;

  & span {
    position: absolute;
    font-size: 1.5rem;
    line-height: 0rem;
  }

  & .unreadMsgDot {
    color: #d63384;
    left: -5px;
    bottom: 0;
  }

  & .activeTaskDot {
    right: -5px;
    bottom: 0;
    color: #fd7e14;
  }
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 9999px;
  object-fit: cover;
  border: 2px solid #2a8fe6;
}

.accountMenuPanel {
  position: absolute;
  right: 0;
  top: calc(100% + 0.3rem);
  min-width: 14rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  z-index: 40;
  padding: 0.35rem;

  & hr {
    margin: 0.25rem 1rem;
  }
}

.userName {
  color: var(--bs-gray-600);
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  padding: 0.5rem;
}

.accountMenuItem {
  display: block;
  text-decoration: none;
  color: #111827;
  border-radius: 0.4rem;
  padding: 0.45rem 1rem;
  position: relative;

  &:hover {
    background: #f3f4f6;
  }

  & img {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.5rem;
    opacity: 0.6;
    vertical-align: text-bottom;
  }

  &.unreadMsgDot::after {
    position: absolute;
    content: '•';
    font-size: 1.5rem;
    color: #d63384;
    right: 0.35rem;
    top: 0.15rem;
    left: unset;
    line-height: 2rem;
  }

  &.activeTaskDot::after {
    position: absolute;
    content: '•';
    font-size: 1.5rem;
    color: #fd7e14;
    right: 0.35rem;
    top: 0.15rem;
    line-height: 2rem;
  }
}
